'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-6a5a8a7f.js');
var React = require('react');
var context = require('@amzn/stencil-react-components/context');
var card = require('@amzn/stencil-react-components/card');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var StickyContainer = function StickyContainer(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default["default"].createElement(StickyCard, {
    className: className
  }, children);
};
var StickyCard = context.styledWithTheme(card.Card)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n"])));

exports.StickyContainer = StickyContainer;
//# sourceMappingURL=stickycontainer-e192fe49.js.map
